import { component } from "picoapp";

export const gridVideo = component((node: HTMLElement) => {
  const video = node.querySelector<HTMLVideoElement>("video");
  const pauseButton = node.querySelector<HTMLElement>("[data-pause]");
  const playButton = node.querySelector<HTMLElement>("[data-play]");

  const pauseVideo = () => {
    if (video) {
      video.pause();
    }
    if (pauseButton) {
      pauseButton.style.display = "none";
    }
    if (playButton) {
      playButton.style.display = "block";
    }
  };

  const playVideo = () => {
    if (video) {
      video.play();
    }
    if (playButton) {
      playButton.style.display = "none";
    }
    if (pauseButton) {
      pauseButton.style.display = "block";
    }
  };

  pauseButton?.addEventListener("click", pauseVideo);

  playButton?.addEventListener("click", playVideo);

  return () => {
    pauseButton?.removeEventListener("click", pauseVideo);
    playButton?.removeEventListener("click", playVideo);
  };
});
